export const themes = {
  default: ({ color, colorBorder, orientation }) => ({
    thRoot: 'reset-button flex relative justify-center',
    thInner: `bg-${color} border-${orientation === 'top' ? 't' : 'b'}-1 border-${colorBorder} -m${
      orientation === 'top' ? 'x' : ''
    }-px overflow-hidden px-1 stripButton-text p${
      orientation === 'top' ? 't' : 'b'
    }-2 whitespace-no-wrap`,
  }),
};
